import {
    DataGrid,
    GridActionsCellItem,
    GridToolbarContainer,
  } from "@mui/x-data-grid";
  import React, { useEffect, useState } from "react";
  import { useSelector } from "react-redux";
  import { getFIles, GetUsers, fetchFile, downloadFiles } from "../../Services/api";
  import instance from "../../redux/api";
  import { CommonButton } from "../common/commonButton";
  import format from 'date-fns/format';
  import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormLabel,
    Grid,
    IconButton,
    Stack,
    TableContainer,
    TextField,
    Tooltip,
  } from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import { toast } from "react-toastify";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonSelect, CommonPaginationContainer } from "../common";
import { getPaginationCount } from "../CashAllocation/utils";  
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import * as XLSX from "xlsx";
import { CircularProgress } from "@mui/material";
import { downloadFileModdules } from "../CashAllocation/constants";
import { commonToast } from "../common";
  //styles
  
  const AssignBankStatementBar = {
    display: "flex",
    justifyContent: "space-between",
    height: 32,
    fontWeight: "400",
    marginTop: 10,
  };
  const editEntityUpdate = {
    width: "90px",
    padding: "18px 0px",
    borderRadius: "20px",
    gap: "8px",
  };
  
  const bankTransactionAddBtn = {
    background: "#FF5A01",
    marginLeft: "5%",
    color: "white",
    borderRadius: "10px",
    padding: "5px 20px",
  };
  
  const bankStatementSearchBar = {
    width: "230px",
    height: "30px",
    padding: "2px 5px 1px 15px",
    borderRadius: "7px",
    border: "1px solid #d2cccc",
    marginTop: "5px",
  };
  
  const dialogStyle = {
    maxWidth: "90vw",
    width: "90vw",
    margin: "auto",
  };
  const ResetSubmit = {
    justifyContent: "flex-end",
    paddingTop: "0px",
    marginRight: "12px",
  };
  const addBankTransactionReset = {
    backgroundColor: "white",
    width: "90px",
    padding: "16px 0px",
    borderRadius: "20px",
    gap: "8px",
    color: "black",
    border: "1px solid black",
  };
  
  const EditPageContainerTransactions = {
    padding: "10px",
    cursor: "default",
    width: "100%",
    marginLeft: "-10px",
  };
  const EditPageContainerTransactionsList = {
    display: "flex",
    justifyContent: "end",
    width: "100%",
    alignItems: "center",
    marginBottom: "10px",
  };
  
  const CloseIconStyle = {
    backgroundColor: "#3B3F44",
    color: "#ffff",
    height: "16px",
    width: "16px",
    padding: "7px 8px",
    borderRadius: "32px",
  };
  const addBankTransactionSubmit = {
    backgroundColor: "#FF5A01",
    width: "90px",
    padding: "17px 0px",
    borderRadius: "13px",
    gap: "8px",
    color: "white",
  };
  const downloadBtn = {
    background: "#FF5A01",
    marginLeft: "5%",
    color: "white",
    borderRadius: "10px",
    padding: "5px 25px !important",
    whiteSpace: "nowrap"
  };
  
  export default function FileManagement() {
    // Selectors
    const toggle = useSelector((state) => state.toggleSideMenu);
    const { userData } = useSelector((state) => state?.user);
    
    const Container = {
        width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
        display: "flex",
        flexDirection: "column",
        gap: 8,
      };
      

    const [tableRows, setTableRows] = useState([]);
    const [isApiCallInprogress, setIsApiCallInprogress] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [fromDateValue, setFromDateValue] = useState("");
    const [toDateValue, setToDateValue] = useState("");
    const [isDownloading, setIsDownloading] = useState([]);
  
    const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
    const classes = useStyles();
    const [searchFieldsPrams, setSearchFieldsPrams] = useState({
      File_Name: "",
      Module_Name: "",
      Uploaded_At: "",
      Uploaded_By: null,
    });
    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    const [isClearPerformed, setIsClearPerformed] = useState(false);
  
    //For pagination
    const [paginationCount, setPaginationCount] = useState(0);
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [pageState, setPageState] = useState({
      isLoading: true,
      data: [],
      total: 0,
      page: 1,
      pageSize: 25,
    });
  
    const UserAuthorisation =
      userData?.user_permissions?.permissions_list['Admin Table Maintenance'];
    // skip 0 means page 1
    const currentSkipNumber = () => {
      return pageState?.page === 1
        ? 0
        : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
    };
  
    useEffect(() => {
      setPaginationCount(
        getPaginationCount(pageState?.total, pageState?.pageSize),
      );
    }, [pageState?.pageSize, pageState?.total]);

    useEffect(() => {
      loadData();
    }, [pageState?.pageSize, pageState?.page]);

    useEffect(() => {
      if (!isClearPerformed) {
        loadData();
      }
    }, [pageState?.pageSize, pageState?.page]);

    useEffect(() => {
      if (isClearPerformed) {
        loadData();
        setIsClearPerformed(false);
      }
    }, [isClearPerformed]);

    useEffect(() => {
      if (isSearchPerformed) {
        const searchFields = searchFieldsPrams;
        if (Object.values(searchFields).every(value => !value) && !toDateValue && !fromDateValue) {
          handleClearSearchList();
        }
      }
    }, [toDateValue, fromDateValue]);

    const handleFieldsInputChange = (name, value) => {
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        [name]: value ?? "",
      });
      if (isSearchPerformed && !value) {
        const searchFields = searchFieldsPrams;
        delete searchFields[name];
        if (Object.values(searchFields).every(value => !value) && !toDateValue && !fromDateValue) {
          handleClearSearchList();
        }
      }
    };

    const handleSearchFiles = async () => {
      try {
        let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;
  
        const { File_Name, Module_Name, Uploaded_At, Uploaded_By } = searchFieldsPrams;
        if (File_Name) {
          queryParams = `${queryParams}&file_name=${File_Name}`;
        }
  
        if (Module_Name) {
          queryParams = `${queryParams}&module_name=${Module_Name}`;
        }
  
        if (Uploaded_At) {
          queryParams = `${queryParams}&uploaded_at=${Uploaded_At}`;
        }
  
        if (fromDateValue) {
          const formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
          queryParams = `${queryParams}&from_date=${formattedFromDateValue}`;
        }
  
        if (toDateValue) {
          const formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
          queryParams = `${queryParams}&to_date=${formattedToDateValue}`;
        }
  
        if (Uploaded_By) {
          queryParams = `${queryParams}&uploaded_by=${Uploaded_By.id}`;
        }
  
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
  
        const response = await instance.get(`${getFIles}${queryParams}`);
  
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        if (response.status === 200) {
          console.log("broker", response);
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ?? [],
            page: 1
          }));
          setIsSearchPerformed(true);
          setPaginationCount(
            Math.floor(response?.data?.count / pageState?.pageSize)
          );
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count ?? 0,
            data: [],
          }));
          setPaginationCount(0);
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        console.log("err", err);
      }
    };

    const handleClearSearchList = () => {
      // loadData();
      setIsSearchPerformed(false);
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        File_Name: "",
        Module_Name: "",
        Uploaded_By: null,
      });
      setFromDateValue("");
      setToDateValue("");
      setPageState((old) => ({
        ...old,
        page: 1
      }));
      setIsClearPerformed(true);
    };

    useEffect(() => {
      loadUserData()
    }, [])

    const loadUserData = async () => {
      try {
        // setUsers
        await instance.get(`${GetUsers}`).then((response) => {
          const filteredUsers = response.data.filter(
            (user) => user.status === "Active"
          );
          setUsers([...new Set(filteredUsers)]);
        })
          
          // setUsers(response.data))
        .catch((error) => console.error("Error : ", error));
      } catch (err) {
        console.error("Error : ", err)
      }
    }
  
    const loadData = async () => {
      try {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));

        let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

        if (isSearchPerformed) {
          const { File_Name, Module_Name, Uploaded_By, Uploaded_At } = searchFieldsPrams;

          if (File_Name) {
            queryParams = `${queryParams}&file_name=${File_Name}`;
          }
          if (Module_Name) {
            queryParams = `${queryParams}&module_name=${Module_Name}`;
          }
          if (Uploaded_By) {
            queryParams = `${queryParams}&uploaded_by=${Uploaded_By.id}`;
          }
          if (Uploaded_At) {
            queryParams = `${queryParams}&uploaded_at=${Uploaded_At}`;
          }
          if (fromDateValue) {
            const formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
            queryParams = `${queryParams}&from_date=${formattedFromDateValue}`;
          }

          if (toDateValue) {
            const formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
            queryParams = `${queryParams}&to_date=${formattedToDateValue}`;
          }
        }
        const response = await instance.get(
          `${getFIles}?${queryParams}`
        );
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        if (response.status === 200) {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ?? [],
          }));
          setPaginationCount(
            Math.floor(response?.data?.count / pageState?.pageSize)
          );
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: [],
          }));
          setPaginationCount(0);
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
        setPaginationCount(0);
        console.error("err", err);
      }
    };
  
    
    const columns = [
      {
        field: "file_name",
        headerName: "File Name",
        // width: 300,
        flex: 3,
        headerAlign: "center",
      },
      {
        field: "module_name",
        headerName: "Module Name",
        // width: 150,
        flex: 1.5,
        headerAlign: "center",
      },
      {
        field: "file_info",
        headerName: "#Records",
        // width: 80,
        flex: 1,
        headerAlign: "center",
        renderCell: (params) => {
          const data = JSON.parse(params.row.file_info);
          return data.record_count;
        }
      },
      {
        field: "file_type",
        headerName: "File Type",
        // width: 80,
        flex: 0.8,
        headerAlign: "center",
      },
      {
        field: "file_size",
        headerName: "File Size",
        // width: 80,
        flex: 1,
        headerAlign: "center",
        renderCell: (params) => (
          <span>{formatFileSize(params?.row?.file_size)}</span>
          ),
      },
      {
        field: "created_by",
        headerName: "Uploaded By",
        // width: 120,
        flex: 1.2,
        headerAlign: "center",
        renderCell: (params) => (
        <span>{params?.row?.created_by?.user_name || ''}</span>
        ),
      },
      {
        field: "created_at",
        headerName: "Uploaded At",
        // width: 120,
        flex: 1.2,
        headerAlign: "center",
        renderCell: (params) => (
            <span>{format(new Date(params.row?.created_at), "dd-MM-yyyy")}</span>
        ),
      },
      {
        field: "action",
        headerName: "Action",
        // width: 120,
        flex: 1.2,
        headerAlign: "center",
        renderCell: (params) => (
              isDownloading.includes(params.row.id) ?
              <CircularProgress
                style={{ color: "rgb(255, 90, 1)" }}
              /> :
              <DownloadIcon
                  style={{ marginRight: 8, cursor: "pointer", color:"#FF5A01" }}
                  titleAccess="Download File"
                  color="green"
                  onClick={() => downloadTheFile(params.row.file_name, params.row.module_name, params.row.id)}
              />
        ),
      }
    ];

    const downloadTheFile = async (file_name, module_name, id) => {
      setIsDownloading([
        ...isDownloading,
        id
      ])
      let module = downloadFileModdules.fileManagement;
      if (module_name=='WF_Bank_Amount_Change'){
        module = downloadFileModdules.workflow;
      }
      const url = `${fetchFile}?key=${encodeURIComponent(file_name)}&moduleName=${module_name}&module=${module}`;

      await instance.get(`${url}`,  { responseType: "blob" })
      .then((response) => {
        setIsDownloading(isDownloading.filter(ids => ids !== id))

        openExcelInNewTab(response.data, file_name)
      })
      .catch((error) => {
        setIsDownloading(isDownloading.filter(ids => ids !== id))
        console.error("Error : ", error)
        commonToast("error", "File could not be downloaded");
      });
    }

    const openExcelInNewTab = (blob, file_name) => {
      const fileReader = new FileReader();
  
      fileReader.onload = (e) => {
        const binaryString = e.target.result;
        const workbook = XLSX.read(binaryString, { type: "binary" });
  
        // Get the first sheet from the Excel file
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
  
        // Convert sheet to HTML
        const htmlString = XLSX.utils.sheet_to_html(sheet);
        const blobURL = URL.createObjectURL(blob);
  
        // Open a new tab and write the HTML content
        const newTab = window.open();

        if(!newTab)
        {
          const link = document.createElement("a");
          link.href = blobURL;
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          return;
        }
        
        newTab.document.write(`
        <html>
          <head>
            <title>Excel File</title>
            <style>
              body {
                font-family: Arial, sans-serif;
              }
              .container {
                padding: 20px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                border: 1px solid #ddd;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 8px 10px;
                text-align: center;
              }
              th {
                background-color: #ffc000; /* Excel-like header color */
                font-weight: bold;
              }
              td {
                background-color: #f9f9f9;
              }
              .download-btn {
                background-color: rgb(255, 90, 1);
                color: white;
                padding: 10px 15px;
                border: none;
                cursor: pointer;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                gap: 8px;
              }
              .download-btn:hover {
                background-color: #ffc000;
              }
            </style>
            </head>
            <body>
            <div class="container">
              <!-- Download Button -->
              
              <button class="download-btn" onclick="downloadExcel()">
                <span><strong>Download Excel</strong></span>
                <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DownloadIcon" style="fill: white"><path d="M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"></path></svg>
              </button>

              <!-- Excel Content -->
              ${htmlString}
            </div>
            </body>
            <script>
              // Function to download the Excel file
              function downloadExcel() {
                const link = document.createElement("a");
                link.href = "${blobURL}";
                link.download = "${file_name}";
                link.click();
              }
            </script>
        </html>
      `);
        newTab.document.close();
      };
  
      // Read the Blob as a binary string
      fileReader.readAsBinaryString(blob);
    };

    const formatFileSize = (bytes) => {
      if(!bytes) return "-";
      if (bytes === 0) return '0 Byte';
      
      const sizes = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(1024)); 
      const fileSize = (bytes / Math.pow(1024, i)).toFixed(2);
      
      return `${fileSize} ${sizes[i]}`;
    }

    const isFilterBtnDisable = () => {
      let disabled = true;
      const { File_Name, Module_Name, Uploaded_By } = searchFieldsPrams;
      if (File_Name !== "" || Module_Name !== "" || Uploaded_By || fromDateValue !== "" || toDateValue !== "") {
        disabled = false;
      }
      return disabled;
    };

    // Handle input change for the search field
    const handleInputChange = (value) => {
        setSearchText(value);
    };

    // Handle change when a user is selected
    // const handleChange = (event, value) => {
    //     setSelectedUser (value);
    // };

    // Filter users based on the search text
    useEffect(() => {
      setFilteredUsers(users.filter(user =>
          user.user_name.toLowerCase().includes(searchText.toLowerCase())
      ));
    }, [searchText, users]);
    
    const handleEnter = (e) => {
      if (e.code === "Enter") {
        handleSearchFiles();
      }
    };

    const handleDownloadBtnClick = () => {
      setIsDownloadInProgress(true);
      try {
        instance
          .get(`${downloadFiles}`, { responseType: "blob" })
          .then((response) => {
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            const fileName = `DocumentRepository_${format(new Date(), "dd-MM-yyyy")}`
            link.setAttribute("download", `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setIsDownloadInProgress(false);
            commonToast("success", "Document Repository data has been downloaded successfully");
          }).catch((err) => {
            console.log(err);
            setIsDownloadInProgress(false);
            commonToast("error", "Document Repository data could not be downloaded");
          });
      } catch (error) {
        setIsDownloadInProgress(false);
        console.log(error);
        commonToast("error", "Document Repository data could not be downloaded");
      }
    }
    
    return (
      <div style={Container}>
        <div style={AssignBankStatementBar}>
          <span style={{ color: "#FF5A01", fontSize: "24px" }}>
            Document Repository
          </span>
          <div style={{ display: "flex", marginRight: "10px" }}>
            {UserAuthorisation?.["Creation"] === "Y" && (
              <>
                <CommonButton
                  text="Export"
                  handleClick={handleDownloadBtnClick}
                  sx={downloadBtn}
                  hoverColor="#FF5A01"
                  disabled={isDownloadInProgress}
                />
              </>
            )}
          </div>
        </div>
        <form onSubmit={(e) => {
          e.preventDefault();
          handleSearchFiles();
        }}>
        <Grid container
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            mb: "10px",
          }}
          xs={12}
          gap={"20px"}
        >
          <Grid item xs={2.5} display={"flex"} flexDirection={"column"} gap={"6px"}>
            <FormLabel>File Name</FormLabel>
            <TextField
              value={searchFieldsPrams?.File_Name}
              onChange={(e) =>
                handleFieldsInputChange("File_Name", e.target.value)
              }
              size="small"
              placeholder="Enter File Name Here"
              onKeyUp={(e) => handleEnter(e)}
            />
          </Grid>
          <Grid item xs={2.5} display={"flex"} flexDirection={"column"} gap={"6px"}>
            <FormLabel>Module Name</FormLabel>
              <TextField
                value={searchFieldsPrams?.Module_Name}
                onChange={(e) =>
                  handleFieldsInputChange("Module_Name", e.target.value)
                }
                size="small"
                placeholder="Enter module name Here"
                onKeyUp={(e) => handleEnter(e)}
              />
          </Grid>
          <Grid item xs={2.5} display={"flex"} flexDirection={"column"} gap={"6px"}>
            <FormLabel>Uploaded By</FormLabel>
              <div onKeyUp={(e) => handleEnter(e)}>  
                <CommonSelect
                  options={users}
                  value={searchFieldsPrams?.Uploaded_By }
                  handleChange={(event, value, reason) => handleFieldsInputChange("Uploaded_By", value )}
                  handleInputChage={handleInputChange}
                  placeholder="Select user name"
                  getOptionKey={(option) => option.id ?? option}
                  getOptionLabel={(option) => option.user_name ?? option}
                  customStyles={{ minWidth: 200 }}
                />
              </div>
          </Grid>
          <Grid item xs={2.5} display={"flex"} flexDirection={"column"} gap={"6px"}>
            <FormLabel>Uploaded At</FormLabel>
              <div onKeyUp={(e) => handleEnter(e)}>
              <CustomDateRangePicker
                startDate={fromDateValue}
                setStartDate={setFromDateValue}
                endDate={toDateValue}
                setEndDate={setToDateValue}
                maxDate={new Date()}
                handleSubmit={(event) => event.preventDefault()}
              />
              </div>
          </Grid>
          <Grid item display={"flex"} gap={"10px"} mt={"22px"} >
            <FormLabel></FormLabel>
            <CommonButton
              text="Search"
              handleClick={handleSearchFiles}
              hoverColor="#EE3F00"
              disabled={pageState?.isLoading || isFilterBtnDisable()}
              type="submit"
            />
            <FormLabel></FormLabel>
            <CommonButton
              text="Reset"
              handleClick={handleClearSearchList}
              hoverColor="#EE3F00"
              disabled={pageState?.isLoading}
              style={{ color: isFilterBtnDisable() ?? "rgba(0, 0, 0, 0.26)" }}
            />
          </Grid>
        </Grid>
        </form>
        <div
          style={{
            height: "calc(100vh - 240px)",
            position: "relative",
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          {/* <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            columns={columns}
            rowCount={pageState?.total}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            paginationMode="server"
            // getRowId={(row) => row?.id}
            getRowId={(row) => pageState?.data.indexOf(row)}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 10}
            rowsPerPageOptions={[2, 10, 25, 50, 100]}
            
            onPageSizeChange={(newPageSize) => {
              // return setPageState((old) => {
              //   console.log("setPaginationCount 5 : ", pageState)
              //   setPaginationCount(Math.floor(pageState.total / newPageSize));
              //   return { ...old, pageSize: newPageSize, page: 1 };
              // });
              return setPageState((old) => {
                setPaginationCount(
                  getPaginationCount(pageState?.total, newPageSize),
                );
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            components={{
              Toolbar: GridToolbarContainer, // Custom toolbar for filter reset button
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No files found
                </Stack>
              ),
            }}
            sx={{
              "& .MuiDataGrid-columnHeader[data-field='actions']": {
                minWidth: toggle?.isOpen
                  ? "106px !important"
                  : "123px !important",
              },
            }}
          />
           <Stack
            style={{
              position: "absolute",
              bottom: "8px",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack> */}
          <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            getRowId={(row) => pageState?.data.indexOf(row)}
            rowCount={pageState?.total}
            columns={columns}
            disableRowSelectionOnClick
            keepNonExistentRowsSelected
            pagination
            paginationMode="server"
            disableSelectionOnClick
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            onPageSizeChange={(newPageSize) => {
              return setPageState((old) => {
                setPaginationCount(
                  getPaginationCount(pageState?.total, newPageSize),
                );
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{
              "& .MuiDataGrid-columnHeader[data-field='File_Name']": {
                minWidth: toggle?.isOpen
                  ? "170.137px !important"
                  : "198px !important",
              },
            }}
            components={{
              Toolbar: GridToolbarContainer,
              NoRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  No Uploaded Files
                </Stack>
              ),
            }}
        />
        <Stack
          style={{
            position: "absolute",
            bottom: "8px",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
        </div>
      </div>
    );
  }
  